import { type ReactNode, useCallback } from 'react'
import { showToast as sonnerShow, Toast } from '../components/molecules/Toast'

export const ToastProvider = ({ children }: { children: ReactNode }) => (
  <>
    {children}
    <Toast />
  </>
)

export const useToast = () => ({
  showToast: useCallback((message: string, type: 'error' | 'success') => {
    sonnerShow(message, type)
  }, []),
})
